import { useState, useRef } from 'react';
import { GlobalStateContext } from './global-state-context';
import PropTypes from 'prop-types';

export const GlobalStateProvider = ({ children, ...props }) => {
	const { isError: initialError, isNotFound: initialNotFound, ...initialData } = props.initialData ?? {};

	const [isNotFound, setIsNotFound] = useState(initialNotFound);
	const [isError, setIsError] = useState(initialError);
	const globalStateRef = useRef(initialData ?? {})
	const [globalState, setGlobalStateRaw] = useState(globalStateRef.current);

	const setGlobalState = (newState) => {
		globalStateRef.current = newState;
		setGlobalStateRaw(newState);
	}

	const setNotFound = (notFound = true) => {
		setIsNotFound(!!notFound);
	}

	const setError = (err = true) => {
		setIsError(!!err);
	}

	const setData = (key, value) => {
		setGlobalState({ ...globalStateRef.current, [key]: value });
	}
	
	const removeData = (key) => {
		const {[key]: keyedData, ...newGlobalState} = globalStateRef.current;

		setGlobalState(newGlobalState);
	}

	return (
		<GlobalStateContext.Provider value={{ initialized: true, ...globalState, isNotFound, isError, setData, removeData, setNotFound, setError }}>
			{children}
		</GlobalStateContext.Provider>
	)
}

GlobalStateProvider.propTypes = {
	children: PropTypes.node.isRequired,
	initialData: PropTypes.object,
}